import {
    GET_TESTIMONIAL,
    GET_TESTIMONIAL_FAIL,
    GET_TESTIMONIAL_SUCCESS,
    GET_TESTIMONIAL_RESET,
} from "../action/getTestimonialAction";

import { api_err_msg } from "../strings.json";

const initialState = {
    apiState: "",
    list: [],
    message: "",
    pagination: {},
};

export default function (state = initialState, action) {
    console.log('action.type',action.type);
    switch (action.type) {
        case GET_TESTIMONIAL:
            return {
                ...state,
                apiState: "loading",
            };
            case GET_TESTIMONIAL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            };
            case GET_TESTIMONIAL_SUCCESS:
            return {
                ...state,
                apiState: "sucess",
                list: action.response.data.data,
                pagination: action.response.data.data.pagination,
            };
            case GET_TESTIMONIAL_RESET:
            return initialState;
        default:
            return state;
    }
}